import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_private/_route/teams/$teamId/candidates/$candidateId/$tabId')({
  beforeLoad: ({ params}) => {
    throw redirect({ params, to: '/teams/$teamId/candidates/$candidateId/activity' })
  }
})
